import { render, staticRenderFns } from "./blok_auction.vue?vue&type=template&id=dba406f8&scoped=true&"
import script from "./blok_auction.vue?vue&type=script&lang=js&"
export * from "./blok_auction.vue?vue&type=script&lang=js&"
import style0 from "./blok_auction.vue?vue&type=style&index=0&id=dba406f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba406f8",
  null
  
)

export default component.exports